<template>
  <v-system-bar
    v-if="
      tipoart === 'Maquina' &&
      (Object.entries(EspecifTecnica).length!==0 || Object.entries(Seccion).length!==0 || dsCaracteristicas.ttinmaecar) &&
      $vuetify.breakpoint.mdAndUp
    "
    class="rounded-md"
    :class="$vuetify.breakpoint.mdAndUp ? 'fixed-bar' : 'fixed-bar2'"
    dark
    :height="$vuetify.breakpoint.mdAndUp ? 30 : 48"
    color="primary"
  >
    <div class="mx-auto mt-1">
       <span
        v-if="dsCaracteristicas.ttinmaecar"
        style="cursor:pointer"
        @click="$vuetify.goTo('#Feature', options)"
        class="font-weight-bold mr-5 white--text"
        ><v-icon class="mt-n1" color="white" size="19">
          mdi-chevron-down
        </v-icon>
        Características</span
      >
      <span
        v-if="Object.entries(EspecifTecnica).length!==0 && dataUser.IndAutenticado"
        @click="$vuetify.goTo('#Ficha', options)"
        style="color: white; cursor: pointer"
        class="font-weight-bold ml-n2"
      >
        <v-icon class="mt-n1"> mdi-chevron-down </v-icon>
        Especificaciones Técnicas
      </span>

      <span
        v-if="Object.entries(Seccion).length!==0"
        @click="$vuetify.goTo('#Repuesto', options)"
        style="color: white; cursor: pointer"
        class="font-weight-bold"
      >
        <v-icon class="mt-n1 ml-4"> mdi-chevron-down </v-icon>
        Repuestos
      </span>
       <span
        v-if="Object.entries(MaquinaRep).length!==0"
        @click="$vuetify.goTo('#MaquinaRep', options)"
        style="cursor:pointer"
        class="font-weight-bold white--text"
      >
        <v-icon class="mt-n1 ml-4" color="white" size="19">
          mdi-chevron-down
        </v-icon>
        Maquinas
      </span>
      <span
        @click="$vuetify.goTo('#Manuals', options)"
        style="color: white; cursor: pointer"
        class="font-weight-bold"
         v-if="GetManual() && false"
      >
        <v-icon class="mt-n1 ml-4" color="white" size="19">
          mdi-chevron-down
        </v-icon>
        Manuales
      </span>
      <span
        v-if="despiece != ''"
        style="color: white; cursor: pointer"
        class="font-weight-bold"
      >
        <v-icon class="mt-n1 ml-4"> mdi-chevron-down </v-icon>
      </span>
      
    </div>
  </v-system-bar>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  data() {
    return {
      fab: false,
      md: true,
      offset: 35,
      duration: 300,
    };
  },
  props: {
    despiece: String,
    tipoart: String,
  },
  components: {},
  computed: {
      ...mapGetters(["isManual"]),
    ...mapState([
      "Articulo",
      "MaquinaRep",
      "dataUser",
      "EspecifTecnica",
      "dsCaracteristicas",
      "imgMarcas",
      "imgPeque",
      "Seccion",
    ]),
     options () {
        return {
         duration: this.duration,
          offset: this.offset,
         
        }
      },

    codigoArt: function () {
      return function (id) {
        if (this.Articulo) {
          var nb = this.Articulo.filter((x) => x.Codigo === id).map(
            (x) => x.Codigo
          );
          return nb.toString();
        }
      };
    },

    codArticulo: {
      get: function () {
        return this.$route.params.codart;
      },
    },
  },
   created(){
   this.GetManual()
  
  },
  methods: {
      GetManual() {
  

    if(this.isManual)
       return this.isManual
   
    },
  },
};
</script>

<style scoped>
.fixed-bar {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 6.5em;
  z-index: 2;
}
.fixed-bar2 {
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  top: 5.9em;
  z-index: 2;
}
.nolink {
  text-decoration: none;
  color: inherit;
}
</style>